export enum Gender {
  Female = 'Female',
  Male = 'Male',
  NonBinary = 'NonBinary',
  PreferNotToAnswer = 'PreferNotToAnswer'
}
